import { useModal, useOverlay } from "@react-aria/overlays";

import { FocusScope } from "@react-aria/focus";
import PropTypes from "prop-types";
import React from "react";
import { mergeProps } from "@react-aria/utils";
import { useDialog } from "@react-aria/dialog";
import { StyledPopOver } from "./RangeCalendarPopOver.styles";

const RangeCalendarPopOver = React.forwardRef(
    (
        {
            _title,
            children,
            isOpen,
            onClose,
            style,
            marginTop = 20,
            ...otherProps
        },
        ref
    ) => {
        const { overlayProps } = useOverlay(
            {
                onClose,
                isOpen,
                isDismissable: true,
            },
            ref
        );
        const { modalProps } = useModal();
        const { dialogProps } = useDialog({}, ref);

        return (
            <FocusScope restoreFocus>
                <StyledPopOver
                    {...mergeProps(
                        overlayProps,
                        dialogProps,
                        otherProps,
                        modalProps
                    )}
                    ref={ref}
                    style={{
                        ...style,
                    }}
                    $marginTop={marginTop}
                >
                    {children}
                </StyledPopOver>
            </FocusScope>
        );
    }
);

RangeCalendarPopOver.propTypes = {
    _title: PropTypes.string,
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    style: PropTypes.object,
    marginTop: PropTypes.number,
};

export default RangeCalendarPopOver;
